<div class="thank-you-img">
  <img src="/assets/image/thankyou-confirm.png" alt="" />
</div>
<div class="thank-you-text">
  <h4>{{'Login Sucessful'}}</h4>
  <p>
    {{'You have successfully signed into your account.'}}
  </p>
  <p>
  {{'You can close this window and continue using the product.'}}
</p>
</div>